import React from "react";
import { Link } from "react-router-dom";
import Header from "../homepage/components/Header";
import Footer from "../homepage/components/Footer";
import Seo from "../../components/Seo";

const ShowreelPage = () => {
  const youtubeId = "Ca-Q0gGLPaU";
  const videoSchema = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: "Skyline VFX Show Reel",
    description: "Show reel featuring digital matte painting, environment design, and VFX set extensions.",
    embedUrl: `https://www.youtube-nocookie.com/embed/${youtubeId}`,
  };

  return (
    <>
      <Seo
        title="Show Reel - Skyline VFX"
        description="Show reel for Skyline VFX."
        schema={videoSchema}
      />
      <div className="min-h-screen text-white">
        <Header />
        <main className="pt-16 pb-20 px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            {/* Match Portfolio page title + subtitle */}
            <div className="text-center mb-12">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">Portfolio</h2>
              <p className="text-gray-400 max-w-2xl mx-auto">
                A selection of digital matte paintings and concept art from film and television projects.
              </p>
            </div>

            {/* Section Switcher (matches Portfolio filters) */}
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              <Link
                to="/portfolio?category=matte-painting"
                className="px-6 py-3 text-sm font-medium transition-all border border-white/15 bg-white/5 text-gray-300 hover:bg-white/10 hover:text-white"
              >
                Matte Painting
              </Link>
              <Link
                to="/portfolio?category=concept-art"
                className="px-6 py-3 text-sm font-medium transition-all border border-white/15 bg-white/5 text-gray-300 hover:bg-white/10 hover:text-white"
              >
                Concept Art
              </Link>
              <Link
                to="/showreel"
                aria-current="page"
                className="px-6 py-3 text-sm font-medium transition-all border border-white/15 bg-[#ffab3e] text-black"
              >
                Show Reel
              </Link>
            </div>

            <div className="bg-black border border-black">
              <div className="relative w-full aspect-video bg-black">
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0&modestbranding=1&playsinline=1`}
                  title="Skyline VFX Show Reel"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ShowreelPage;

